import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { verifyApi, userDetails } from "../helpers/axios";

export const details = createAsyncThunk("userDetails", async (token) => {

  try {
    const response = await userDetails(token);
    // console.log(response);
    return response;
  } catch (error) {
    console.log(error);
    throw new Error(error.message);
  }
});

export const verify = createAsyncThunk("verify", async (token) => {
  try {
    const response = await verifyApi(token);
    // console.log(response);
    return response;
  } catch (error) {
    console.log(error);
    throw new Error(error.message);
  }
});

const initialState = {
  token: "",
  username: "",
  photoObj: {},
  photo: "",
  userToken: null,
  loading: false,
  error: false,
  isVerified: false,
  userAuthError: null,
  isAuthenticated: false,
};

const userAuthenticationSlice = createSlice({
  name: "userAuth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(details.pending, (state) => {
        state.loading = true;
      })
      .addCase(details.fulfilled, (state, action) => {
        state.loading = false;
        state.isVerified = true;
        state.token = action.payload?.token;
      })
      .addCase(details.rejected, (state, action) => {
        state.loading = false;
        state.error = true
        state.userAuthError = action.error.message;
        toast.error(state.userAuthError);
      })
      .addCase(verify.pending, (state) => {
        state.loading = true;
      })
      .addCase(verify.fulfilled, (state, action) => {
        state.loading = false;
        state.isVerified = true;
        state.username = action.payload?.user?.username;
        sessionStorage.setItem(
          "userId",
          JSON.stringify(action.payload?.user?.id)
        );
        sessionStorage.setItem("username", JSON.stringify(state.username));
        state.photo = action.payload?.user?.imageUrl ? action.payload?.user?.imageUrl : null
        sessionStorage.setItem("profileImg", JSON.stringify(state.photo));
      })
      .addCase(verify.rejected, (state, action) => {
        state.loading = false;
        state.error = true
        state.userAuthError = action.error.message;
        toast.error(state.userAuthError);
      });
  },
});

export default userAuthenticationSlice.reducer;
